/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { SegmentedOption } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function NotificationsView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '840px',
        margin: '0 auto',
        padding: '24px 12px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        {' '}
        <div> </div> <div style={{ flex: '1' }}></div>{' '}
        <button
          className="scp-6bc9eb5"
          onClick={m.notifMarkAllRead}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '11.5px',
            padding: '7px 14px',
            borderRadius: '99px',
            border: '1px solid var(--l12)',
            background: 'transparent',
            color: 'var(--text-mid)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-checks" style={{ fontSize: '12px' }}></i>Mark all read
        </button>{' '}
      </div>{' '}
      <div
        style={{
          display: 'flex',
          gap: '2px',
          padding: '3px',
          borderRadius: '99px',
          border: '1px solid var(--l8)',
          alignSelf: 'flex-start',
          flexWrap: 'wrap',
        }}
      >
        {' '}
        {(m.notifTabs ?? []).map((t, i174) => (
          <Fragment key={i174}>
            <SegmentedOption bg={t?.bg} fg={t?.fg} variant="e" onClick={t?.go}>
              {dc.t(t?.label)}
            </SegmentedOption>
          </Fragment>
        ))}{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          overflow: 'hidden',
        }}
      >
        {' '}
        {(m.notifList ?? []).map((n, i175) => (
          <Fragment key={i175}>
            {' '}
            <div
              className="scp-3d4c232"
              style={dc.css(
                `display:flex;gap:12px;padding:14px 18px;border-bottom:1px solid var(--l5);background:${dc.s(n?.rowBg)}`,
              )}
            >
              {' '}
              <div
                style={dc.css(
                  `width:32px;height:32px;border-radius:9px;background:${dc.s(n?.bg)};display:flex;align-items:center;justify-content:center;flex:none`,
                )}
              >
                <i
                  className={`ph ${dc.s(n?.icon)}`}
                  style={dc.css(`font-size:16px;color:${dc.s(n?.col)}`)}
                ></i>
              </div>{' '}
              <div style={{ flex: '1', minWidth: '0' }}>
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={dc.css(
                      `font-size:9px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:${dc.s(n?.col)}`,
                    )}
                  >
                    {dc.t(n?.type)}
                  </span>
                  <div style={{ flex: '1' }}></div>
                  <span style={{ fontSize: '10.5px', color: 'var(--faint)' }}>{dc.t(n?.when)}</span>
                </div>{' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500', marginTop: '3px' }}>
                  {dc.t(n?.title)}
                </div>{' '}
                <div
                  style={{ fontSize: '11.5px', color: 'var(--muted)', lineHeight: '1.55', marginTop: '3px' }}
                >
                  {dc.t(n?.body)}
                </div>{' '}
              </div>{' '}
              <div
                style={dc.css(
                  `width:8px;height:8px;border-radius:50%;background:${dc.s(n?.col)};border:${dc.s(n?.dotBd)};flex:none;margin-top:4px;opacity:0.9`,
                )}
              ></div>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>
    </div>
  );
}
